
// src/config.js

// 1. Determine environment-aware SITE_URL (for canonicals and absolute links)
let SITE_URL = "http://localhost:3000"; // Fallback for local dev

if (typeof window !== "undefined") {
    SITE_URL = window.location.origin;
} else if (import.meta.env.VITE_SITE_URL) {
    SITE_URL = import.meta.env.VITE_SITE_URL;
}

// 2. Get Raw API Env Var & Implement Fail-Safe Smart Detection
let RAW_ENV_VAR = import.meta.env.VITE_API_BASE;

if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    // Force production API if we are definitely on the production domain
    if (hostname.endsWith("antaryatra-app.com") && !hostname.includes("stag")) {
        RAW_ENV_VAR = "https://api.antaryatra-app.com";
    } 
    // Force staging API if we are definitely on the staging domain
    else if (hostname.includes("stag") || hostname.includes("vercel.app")) {
        RAW_ENV_VAR = "https://api-stag.antaryatra-app.com";
    }
}

// Fall back to "" (relative URLs) so HTTP→HTTPS mixed content errors never occur on deployed environments.
let RAW_API_BASE = RAW_ENV_VAR || "";

// Remove trailing slash
let CLEAN_BASE = RAW_API_BASE.replace(/\/$/, "");

// Determine API_URL and API_HOST
let API_URL = CLEAN_BASE;
let API_HOST = CLEAN_BASE;

if (CLEAN_BASE.endsWith("/api")) {
    API_URL = CLEAN_BASE;
    API_HOST = CLEAN_BASE.slice(0, -4); 
} else {
    API_URL = `${CLEAN_BASE}/api`;
    API_HOST = CLEAN_BASE;
}

// 4. WebSocket URL (Default to Host Root)
let WS_URL = import.meta.env.VITE_WS_URL || API_HOST;
if (typeof window !== "undefined" && API_HOST.includes("api.antaryatra-app.com") && !API_HOST.includes("stag")) {
    WS_URL = "https://api.antaryatra-app.com";
} else if (typeof window !== "undefined" && API_HOST.includes("api-stag.antaryatra-app.com")) {
    WS_URL = "https://api-stag.antaryatra-app.com";
}

export const CONFIG = {
    // The Host Root (e.g., http://localhost:4000)
    API_HOST: API_HOST,
    // The API Endpoint (e.g., http://localhost:4000/api)
    API_URL: API_URL,
    // Socket.io URL
    WS_URL: WS_URL,
    // Site Origin (e.g., https://antaryatra-app.com or https://stag.antaryatra-app.com)
    SITE_URL: SITE_URL
};

console.log(`🔌 [ANTARYATRA] ENV: ${import.meta.env.MODE} | SITE: ${SITE_URL} | API: ${API_URL}`);
